export default function Footer() {
  return (
    <footer className="w-full bg-gray-100 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div>
            <span className="text-base font-black text-gray-900 tracking-tight whitespace-nowrap">
              대구싱크대 키친스
            </span>
            <p className="mt-3 text-xs text-gray-500 leading-relaxed">
              대구싱크대 키친스 | 대표 신우창<br />
              대구광역시 북구 침산남로48<br />
              사업자등록번호 503-17-45896<br />
              대구·경북 지역 한정 주방가구 전문 시공업체<br />
              고객센터 <a href="tel:010-4016-8890" className="hover:text-gray-800 cursor-pointer">☎ 010-4016-8890</a> | 개인정보관리책임자 신우창<br />
              견적문의 <a href="mailto:hanskid@naver.com" className="hover:text-gray-800 cursor-pointer">✉ hanskid@naver.com</a>
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-4">
              <a
                href="https://blog.naver.com/hanskid"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-yellow-400 hover:bg-yellow-500 transition-colors rounded-full text-xs font-bold text-gray-900 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-article-line text-sm"></i>
                블로그 바로가기
              </a>

            </div>
            <div className="flex items-center gap-4 text-xs text-gray-500">
              <a href="/?mode=policy" className="hover:text-gray-800 cursor-pointer">이용약관</a>
              <a href="/?mode=privacy" className="hover:text-gray-800 cursor-pointer">개인정보처리방침</a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-400 text-center">
            <strong>Copyright ⓒ 2024 대구싱크대 키친스 All rights reserved.</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}
